// extracted by mini-css-extract-plugin
export default {"statisticsCard":"statisticsCard_statisticsCard__5wmGe","cardTitle":"statisticsCard_cardTitle__lHx9t","orange":"statisticsCard_orange__Gdv6e","purple":"statisticsCard_purple__OU+Oe"};